import { render } from "./TeacherApplicationView.vue?vue&type=template&id=48654b55"
import script from "./TeacherApplicationView.vue?vue&type=script&lang=js"
export * from "./TeacherApplicationView.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TeacherApplicationView.vue?vue&type=style&index=0&id=48654b55&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__